import { SITE } from "../lib/site";

export default function QRCodeReview({ size = 240, title = "Scan to Leave Us a Review" }) {
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&color=C5A059&bgcolor=0A0A0A&margin=12&data=${encodeURIComponent(
    SITE.googleReviewUrl
  )}`;
  return (
    <div className="flex flex-col items-center text-center" data-testid="qr-review-section">
      <p className="overline mb-4">Google Reviews</p>
      <h3 className="font-display text-3xl md:text-4xl text-white mb-6">{title}</h3>
      <a
        href={SITE.googleReviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block border border-[var(--gold)]/30 p-4 bg-[#0A0A0A] hover:border-[var(--gold)] transition-colors"
        data-testid="qr-link"
      >
        <img src={qrSrc} alt="Scan to leave a Google review" width={size} height={size} />
      </a>
      <a href={SITE.googleReviewUrl} target="_blank" rel="noopener noreferrer" className="mt-6 btn-primary" data-testid="leave-review-btn">
        Leave a Review
      </a>
    </div>
  );
}
